<template>
<main-content>
    <kt-panel-body v-if="ip_location !== 'IR'">
        <div class="alert alert-danger" role="alert">
            {{ $t('label.ir_ip_error') }}
        </div>
    </kt-panel-body>
    <ivr-form v-else :form_data="form_data" :submit="submit"></ivr-form>
</main-content>
</template>

<script>
    import mainContent from '@/components/main-content'
    import IVRForm from './components/form'
    import $ from 'jquery'
    import {KTApp} from '@/plugins/core/app'
    import {authService, ivrService} from '@/common/api.service'
    import {IvrSettlementVariant} from "@/constants/IvrSettlementVariant";

    export default {
    components: {
        'main-content': mainContent,
        'ivr-form': IVRForm
    },
    computed: {
        form_data: {
            get: function() {
                return this.$store.state.ivr.form_data
            },
            set: function(value) {
                this.$store.commit('ivr/setFormData', value)
            }
        }
    },
    data() {
        return {
            ip_location: '',
            IvrSettlementVariant,
        }
    },
    mounted() {
        authService.get_ip().then(response => {
            this.ip_location = response.data.countryCode;
        });
    },
    methods: {
        submit(e) {
            // this.form_data.merchant_share_percent = $('#merchant_wage').val()
            // this.form_data.merchant_share_percent = 100;

            let form = $('#ivr_form');
            let btn = $('#submit_btn');

            form.validate({
                rules: {
                    farsi_name: {
                        required: true,
                    },
                    english_name: {
                        required: true,
                    },
                    category_code: {
                        required: false,
                    },
                    address: {
                        required: true,
                    },
                    phone_number: {
                        required: true
                    },
                    logo: {
                        required: true
                    },
                    sheba_number: {
                        required: true
                    },
                    settlement_variant: {
                        required: true,
                    },
                    wallet_hashid: {
                        required: () => {
                            return this.form_data.settlement_variant === IvrSettlementVariant.CHARGE_WALLET;
                        },
                    },
                    // merchant_wage: {
                    //     required: true
                    // },
                    // wage: {
                    //     required: true
                    // }
                }
            });

            if(! form.valid()) {
                return;
            }

            KTApp.progress(btn);
            let params = this.$store.getters['ivr/form_data'];
            // add ivr_shop_type for ivr That is 1
            params = {...params,ivr_shop_type:1}

            params.settlement_variant = 1;

            ivrService.create(params).then(response => {
                this.$store.dispatch('gateway/gatewayTab', 3)
                this.$router.push('/gateways')
            })
            .catch(({response}) => {
                if(response.data) {
                    form.validate().showErrors(response.data.data)
                }
                this.showMsg(form, 'danger', response.data.message)
                for (let err in response.data.data) {
                    this.showMsg(form,'danger',response.data.data[err][0]);
                }
            })
            .finally(() => {
                KTApp.unprogress(btn)
            })
        },
    },
    beforeRouteEnter (to, from, next) {
        next(vm => {
            vm.$store.commit('ivr/clearFormData')
        })
    },
}
</script>

<style>

</style>
